module.exports = __webpack_public_path__ + "img/icone-generic.7ed53ca9.svg";